var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23654 21.913C7.16235 23.2295 9.4911 24 12 24C14.5089 24 16.8376 23.2295 18.7634 21.913L12 20.8695L5.23654 21.913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7634 2.08697C16.8376 0.770484 14.5089 0 12 0C9.4911 0 7.16235 0.770484 5.23654 2.08697L12 3.13045L18.7634 2.08697Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 8.02922 21.6227 4.04156 18.7635 2.08697H5.23655C2.07516 4.24809 0 7.88156 0 12C0 16.1186 2.07516 19.7519 5.23655 21.913H18.7635C21.9249 19.7519 24 16.1186 24 12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3209 19.5749C11.157 19.4342 7.30435 16.0851 7.30435 12C7.30435 7.91489 11.1569 4.56572 11.3209 4.42514L12 3.84305L12.6791 4.42509C12.8431 4.56572 16.6957 7.91484 16.6957 12C16.6957 16.0852 12.8431 19.4343 12.6791 19.5749L12 20.157L11.3209 19.5749Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 12C15.6522 8.34783 12 5.21738 12 5.21738C12 5.21738 8.34784 8.34792 8.34784 12C8.34784 13.1173 8.68989 14.1855 9.16435 15.1305H14.8357C15.3101 14.1855 15.6522 13.1173 15.6522 12Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 12C15.6522 13.1173 15.3101 14.1855 14.8357 15.1305L12 15.6522L9.16435 15.1305C8.68989 14.1855 8.34784 13.1173 8.34784 12H15.6522Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.7826C12 18.7826 13.7591 17.2743 14.8356 15.1305H9.16434C10.2409 17.2743 12 18.7826 12 18.7826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65216 9.91303H14.3478L12 12.2609L9.65216 9.91303Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2174 11.4783H12.7826V16.1739H11.2174V11.4783Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuam);
export default __webpack_public_path__ + "static/media/guam.8e0a5c2ec4d5bf86f76c1cb27da689d5.svg";
export { ForwardRef as ReactComponent };